import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../Componentes/Home";
import ProductoList from "../Componentes/ProductoList";
import Ingreso from "../Componentes/Ingreso";
import Registro from "../Componentes/Registro";

import AltaProd from "../Componentes/AltaProd";
import AltaProveedor from "../Componentes/AltaProveedor";
import ClientesForm from "../Componentes/ClientesForm";
import Salidas from "../Componentes/Salidas";
import ReporteSalidas from "../Componentes/ReporteSalidas";
import Reportes from "../Componentes/Reportes";
import Prestamo from "../Componentes/Prestamos";
import ReportePrestamos from "../Componentes/ReportePrestamos";
import ReporteIngreso from "../Componentes/ReporteIngreso";
import Volver from "../Componentes/Volver";
import ReporteStock from "../Componentes/ReporteStock";
import Devolucion from "../Componentes/Devolucion";
import Autorizados from "../Componentes/Autorizados";
import AltaObra from "../Componentes/AltaObra";
import Layout from "./Layout";

const Rutas = () => (
  <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/ingresos" element={<Ingreso />} />
          <Route path="/clientes" element={<ClientesForm />} />
          <Route path="/altaproducto" element={<AltaProd />} />
          <Route path="/altaproveedor" element={<AltaProveedor />} />
          <Route path="/altaobra" element={<AltaObra />} />
          <Route path="/salidas" element={<Salidas />} />
          <Route path="/reportes" element={<Reportes />} />
          <Route path="/reportes/salidas" element={<ReporteSalidas />} />
          <Route path="/reportes/ingresos" element={<ReporteIngreso />} />
          <Route path="/reportes/prestamos" element={<ReportePrestamos />} />
          <Route path="/reportes/stock" element={<ReporteStock />} />
          <Route path="/prestamos" element={<Prestamo />} />
          <Route path="/devolucion" element={<Devolucion />} />
          <Route path="/autorizados" element={<Autorizados />} />
        </Route>
      </Routes>
      <Volver />
  </BrowserRouter>
);

export default Rutas;